import Lottie from 'lottie-react'
import timeAnimation from '../../assets/animations/time.json'

interface TimeIconProps {
  size?: number
  className?: string
}

const TimeIcon = ({ size = 24, className = '' }: TimeIconProps) => {
  return (
    <div style={{ width: size, height: size, aspectRatio: '1 / 1', contain: 'layout' }} className={className}>
      <Lottie
        animationData={timeAnimation}
        loop={true}
        autoplay={true}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  )
}

export default TimeIcon